import * as React from "react";
import getConfig from "next/config";
import { RecaptchaProvider, RecaptchaContext } from "@grandvisionhq/recaptcha";
import { getDisplayName } from "@grandvisionhq/utils";
function withRecaptcha() {
  return (PageComponent) => {
    const displayName = getDisplayName(PageComponent);
    const WithRecaptcha = (pageProps) => {
      const { publicRuntimeConfig } = getConfig();
      return /* @__PURE__ */ React.createElement(RecaptchaProvider, { config: publicRuntimeConfig.recaptcha }, /* @__PURE__ */ React.createElement(RecaptchaContext.Consumer, null, (recaptchaContext) => /* @__PURE__ */ React.createElement(PageComponent, { ...pageProps, recaptchaContext })));
    };
    WithRecaptcha.displayName = `WithRecaptcha(${displayName})`;
    if (PageComponent.getInitialProps) {
      WithRecaptcha.getInitialProps = PageComponent.getInitialProps;
    }
    return WithRecaptcha;
  };
}
export {
  withRecaptcha
};
//# sourceMappingURL=with-recaptcha.js.map
